import { render, staticRenderFns } from "./BillingAdjustments.vue?vue&type=template&id=c8bff938"
import script from "./BillingAdjustments.vue?vue&type=script&lang=js"
export * from "./BillingAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports